import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable } from "rxjs"
import { SchoolInvoiceDetailCreateRequestDTO, SchoolInvoiceDetailDTO, SchoolInvoiceDetailUpdateRequestDTO, SchoolInvoiceDetailList, SchoolInvoiceDetailDeleteRequestDTO, SchoolInvoiceDetailReadByIdRequestDTO, SchoolInvoiceDetailReadByMasterIdRequestDTO, SchoolInvoiceDetailReadByinvoiceIdRequestDTO } from "./receipt-detail.interface"
import { SchoolInvoiceDetail_Create, SchoolInvoiceDetail_Update, SchoolInvoiceDetail_ReadAll, SchoolInvoiceDetail_Delete, SchoolInvoiceDetail_ReadById, SchoolInvoiceDetail_ReadByMasterId, SchoolInvoiceDetail_ReadByInvoiceId } from "src/app/GlobalVariable"

@Injectable({
    providedIn: 'root'
})
export class SchoolInvoiceDetailService {

    constructor() { }
    http = inject(HttpClient)

    SchoolInvoiceDetail_Create(data: SchoolInvoiceDetailCreateRequestDTO): Observable<SchoolInvoiceDetailDTO> {
        return this.http.post<SchoolInvoiceDetailDTO>(SchoolInvoiceDetail_Create, data)
    }

    SchoolInvoiceDetail_Update(data: SchoolInvoiceDetailUpdateRequestDTO): Observable<SchoolInvoiceDetailDTO> {
        return this.http.post<SchoolInvoiceDetailDTO>(SchoolInvoiceDetail_Update, data)
    }

    SchoolInvoiceDetail_ReadAll(): Observable<SchoolInvoiceDetailList> {
        return this.http.get<SchoolInvoiceDetailList>(SchoolInvoiceDetail_ReadAll)
    }
    SchoolInvoiceDetail_Delete(data: SchoolInvoiceDetailDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SchoolInvoiceDetail_Delete, data)
    }


    SchoolInvoiceDetail_ReadById(data: SchoolInvoiceDetailReadByIdRequestDTO): Observable<SchoolInvoiceDetailDTO> {
        return this.http.post<SchoolInvoiceDetailDTO>(SchoolInvoiceDetail_ReadById, data)
    }

    SchoolInvoiceDetail_ReadByMasterId(data: SchoolInvoiceDetailReadByMasterIdRequestDTO): Observable<SchoolInvoiceDetailList> {
        return this.http.post<SchoolInvoiceDetailList>(SchoolInvoiceDetail_ReadByMasterId, data)
    }

    SchoolInvoiceDetail_ReadByInvoiceId(data: SchoolInvoiceDetailReadByinvoiceIdRequestDTO): Observable<SchoolInvoiceDetailList> {
        return this.http.post<SchoolInvoiceDetailList>(SchoolInvoiceDetail_ReadByInvoiceId, data)
    }

}
